import { pickBy } from 'es-toolkit'
import dynamicCookieRef from './dynamicCookieRef'

/**
 * Memorizes query parameters in a cookie.
 * @param prefix The prefix of the query parameters to memorize. e.g. 'utm_'
 */
export default (prefix: string) => {
  const nuxtApp = useNuxtApp()
  const query = nuxtApp.$router.currentRoute.value.query

  const key = `params-memory[${prefix}]`
  const params = dynamicCookieRef<Record<string, any>>(key)

  const newParams = pickBy(query, (_, key) => key?.startsWith(prefix))
  if (Object.keys(newParams).length) {
    params.value = newParams
  }

  return {
    params,
  }
}
